import _ from "lodash";
import { flow, types } from "mobx-state-tree";
import { getEnv } from "~/mobx/utils/getEnv";
import { Species } from "./Species";
import type { SpeciesInstance, SpeciesSnapshotIn } from "./Species";
import type { AxiosResponse } from "axios";
import type { Instance, SnapshotIn, SnapshotOut } from "mobx-state-tree";

export interface SpeciesStoreInstance extends Instance<typeof SpeciesStore> {}
export interface SpeciesStoreSnapshotIn
  extends SnapshotIn<typeof SpeciesStore> {}
export interface SpeciesStoreSnapshotOut
  extends SnapshotOut<typeof SpeciesStore> {}

export const SpeciesStore = types
  .model("SpeciesStore", {
    map: types.map(Species),
  })
  .actions((self) => {
    return {
      processOne(data: SpeciesSnapshotIn) {
        const existing = self.map.get(data.id);
        if (existing) {
          _.mergeWith(existing, data, (_, next) => {
            if (Array.isArray(next)) return next; // Treat arrays like atoms
          });
          return existing;
        }
        return self.map.put(data as SpeciesSnapshotIn);
      },
    };
  })
  .actions((self) => {
    return {
      processMany(dataList: SpeciesSnapshotIn[]) {
        return dataList.map((data) => {
          return self.processOne(data);
        });
      },
    };
  })
  .actions((self) => {
    return {
      getSpeciesList: flow<SpeciesInstance[], []>(
        function* getSpeciesList(): any {
          const env = getEnv(self);

          const response: AxiosResponse =
            yield env.baseAuthHttp.get("species/");

          const species = response.data.data;

          response.data = self.processMany(species);

          return response.data;
        },
      ),
    };
  });
